var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7865 10.7476C19.7755 10.7583 19.7652 10.7696 19.7557 10.7815L14.4098 17.5928L11.1881 14.3696C10.9692 14.1657 10.6798 14.0546 10.3807 14.0599C10.0816 14.0652 9.79623 14.1864 9.58472 14.3979C9.3732 14.6094 9.25204 14.8947 9.24676 15.1938C9.24148 15.4929 9.3525 15.7824 9.55643 16.0012L13.6294 20.0757C13.7391 20.1852 13.8697 20.2715 14.0135 20.3295C14.1573 20.3874 14.3113 20.4158 14.4663 20.4129C14.6213 20.41 14.7742 20.376 14.9157 20.3127C15.0573 20.2495 15.1847 20.1584 15.2902 20.0449L21.4351 12.3639C21.6443 12.1443 21.7587 11.8512 21.7535 11.5479C21.7484 11.2446 21.624 10.9555 21.4074 10.7432C21.1908 10.5308 20.8994 10.4123 20.596 10.4131C20.2927 10.4139 20.0019 10.5341 19.7865 10.7476Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.4131,
    r: 13.35,
    stroke: "#111111",
    strokeOpacity: 0.5,
    strokeWidth: 3.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked_icon.68b05f23319b1cbe8943f348f90530ce.svg";
export { ForwardRef as ReactComponent };